import React from 'react';
import HomeReverseInfo from '../components/HomeReverseInfo';
import Mission from '../components/Mission';
import News from '../components/News';
const PageMedia = () => {
  return (
    <div>
      <HomeReverseInfo />
      <News />
      <Mission />
    </div>
  );
};

export default PageMedia;
